export const SS_CHANNELS_ID = 'f972b7a1-f8f6-435d-ba99-44f49059e9ef';
export const CONT_CHANNELS_ID = '0e6c10fd-075b-4fa5-a632-09cb198b10ce';
export const DOOR_PULL_OPTION_ID = 'B6850104-AC37-4190-843C-190D47628307';
export const INDICATOR_LATCH_TYPE = 2;
